export const PrayerLable = [
  "Imsaku",
  "Sabahu",
  "L. e Diellit",
  "Dreka",
  "Ikindia",
  "Akshami",
  "Jacia",
];
